import { Modal } from '@flipster/react/design-system-legacy/modal';
import { stack } from '@flipster/styled-system/patterns';

import TopNBids from '../_bid/TopNBids';
import WinnerAnnouncement from '../_bid/WinnerAnnouncement';
import { AuctionDetails, AuctionTitle } from '../_misc/auction';

interface PastAuctionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PastAuctionModal = ({ isOpen, onClose }: PastAuctionModalProps) => {
  return (
    <Modal isOpen={isOpen} size='large' scrollable>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label={<AuctionTitle />} />
      </Modal.Header>
      <Modal.Content
        css={stack.raw({ pb: 60, gap: 40, textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}
      >
        <WinnerAnnouncement />
        <AuctionDetails />
        <TopNBids />
      </Modal.Content>
    </Modal>
  );
};

export default PastAuctionModal;
